import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import CardMedia from "@mui/material/CardMedia";
import Carousel from "react-material-ui-carousel";
import { Contact } from "./pages/Contact";
interface Item {
  name: string;
  description: string;
  img: string;
}
const base_url = `https://www.syon.co.jp/syon-box/`;

const App = () => {
  var items: Item[] = [
    {
      name: "#1 box page01",
      description: "#1",
      img: `${base_url}box01.png`,
    },
    {
      name: "#2 box page02",
      description: "#2",
      img: `${base_url}box02.png`,
    },
    {
      name: "#3 box page03",
      description: "#3",
      img: `${base_url}box03.png`,
    },
    {
      name: "#4 box page04",
      description: "#4",
      img: `${base_url}box04.png`,
    },
  ];

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      direction="column"
    >
      <Grid item md={12} xs={3}>
        <Box>
          {items.map((item, i) => (
            <Item key={i} item={item} />
          ))}
        </Box>
      </Grid>
      <Grid item md={12} xs={3}>
        <Box sx={{ minWidth: 300, maxWidth: "md" }}>
          <Contact />
        </Box>
      </Grid>
    </Grid>
  );
};

function Item(props: any) {
  const { item } = props;
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      direction="column"
    >
      <Grid item md={12} xs={3}>
        <Box sx={{ minWidth: 300, maxWidth: "md" }}>
          <CardMedia
            component="img"
            sx={{
              width: `calc(100vh-50px)`,
              height: `calc(100vh-50px)*2`,
            }}
            image={`${item.img}`}
            alt=""
          />
        </Box>
      </Grid>
    </Grid>
  );
}

export default App;
